import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'next/router';
import { useTranslations } from 'next-intl';

import { navIsOpenToggle, navReset } from '../../../redux/actions/navigation';
import { searchReset } from '../../../redux/actions/search';

import StyledNavButton from './navigationButton.style';

import BurgerIcon from '../../icons/burger.svg';
import CloseIcon from '../../icons/close.svg';
import { accessibilityReset } from '../../../redux/actions/accessibility';

const NavigationButton = props => {
  const {
    navIsOpen,
    close,
    resetNav,
    accessibilityIsOpen,
    searchIsOpen,
    handleOpen,
    inverted = false
  } = props;
  const t = useTranslations();

  useEffect(() => {
    Router.events.on('beforeHistoryChange', resetNav);

    return () => {
      Router.events.off('beforeHistoryChange', resetNav);
    };
  });

  const Icon = close ? CloseIcon : BurgerIcon;
  return (
    <StyledNavButton
      id="navigation-button"
      type="button"
      role="button"
      title={navIsOpen ? t('navigation.close') : t('navigation.open')}
      aria-haspopup="menu"
      aria-expanded={navIsOpen ? 'true' : 'false'}
      onClick={() => handleOpen(accessibilityIsOpen, navIsOpen, searchIsOpen)}
      inverted={inverted}
      close={close}
    >
      <Icon aria-hidden="true" />
      <span className="sr-only">{navIsOpen ? t('navigation.close') : t('navigation.open')}</span>
    </StyledNavButton>
  );
};

NavigationButton.propTypes = {
  navIsOpen: PropTypes.bool.isRequired,
  searchIsOpen: PropTypes.bool.isRequired,
  accessibilityIsOpen: PropTypes.bool.isRequired,
  close: PropTypes.bool,
  inverted: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  resetNav: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  navIsOpen: state.navigation.isOpen,
  searchIsOpen: state.search.isOpen,
  accessibilityIsOpen: state.accessibility.isOpen
});

const mapDispatchToProps = dispatch => ({
  handleOpen: (accessibilityIsOpen, navIsOpen, searchIsOpen) => {
    dispatch(navIsOpenToggle());

    if (navIsOpen) {
      dispatch(navReset());
    }

    if (searchIsOpen) {
      dispatch(searchReset());
    }

    if (accessibilityIsOpen) {
      dispatch(accessibilityReset());
    }
  },
  resetNav: () => dispatch(navReset())
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationButton);
